import { respCodeCheck } from "./error";

export const getUserAuthInfo = async (user_id: string, resourceKey: string) => {
  const result = await fetch(`/api/v2/permission/info?user_id=${user_id}`, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "x-biyi-resource-key": resourceKey,
    },
  });
  const data = await result.json();
  respCodeCheck(data?.base_resp);
  return data;
};
export const getAccountInfo = async (
  account_id: number,
  resourceKey: string,
) => {
  const result = await fetch(`/api/v2/account/info?account_id=${account_id}`, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "x-biyi-resource-key": resourceKey,
    },
  });
  const data = await result.json();
  respCodeCheck(data?.base_resp);
  return data;
};
